import React from 'react';
import PropTypes from 'prop-types';
import Field from "./field";
import ActionButton from "./action_button";

const ConfirmationCode = props => (
  <form className="form">

    <Field handleChange={props.handleChange} id="code" value={props.code} label="Confirmation Code"/>

    <div id="actions">
      <ActionButton onClick={props.onConfirmRegistrationCode} text="Confirm Registration"/>
      <ActionButton onClick={props.onConfirmForgotPasswordCode} text="Confirm Forgot Password"/>
    </div>

  </form>
);

ConfirmationCode.propTypes = {
  code: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  onConfirmRegistrationCode: PropTypes.func.isRequired,
  onConfirmForgotPasswordCode: PropTypes.func.isRequired,
};

export default ConfirmationCode;